import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function PanelNav({ neighbors, onNavigate }) {
  const { t, isRtl } = useLang();
  return (
    <>
      <div className="sticky bottom-0 border-t border-stoneLine bg-card px-6 py-3 flex items-center justify-between">
        <button
          onClick={() => neighbors && onNavigate(neighbors.prev)}
          className="inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-full border border-stoneLine hover:bg-sandDeep/50 transition-colors"
          data-testid="nav-prev"
        >
          {isRtl ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
          {t("prev")}
        </button>
        <button
          onClick={() => neighbors && onNavigate(neighbors.next)}
          className="inline-flex items-center gap-1.5 text-sm px-3 py-2 rounded-full bg-ink text-sand hover:bg-ochre transition-colors"
          data-testid="nav-next"
        >
          {t("next")}
          {isRtl ? <ChevronLeft className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        </button>
      </div>
    </>
  );
}
